import { rem } from '../utils';
import { isSizeType, ThemeSizesTypes } from '../types';

export const column = (value: number | ThemeSizesTypes) => {
  let space = '';

  if (isSizeType(value)) {
    space = `var(--space-${value})`;
  } else {
    space = rem(value);
  }

  return `
        display: flex;
        flex-direction: column;
        gap: ${space};
        
        @supports (-webkit-touch-callout: none) and (not (translate: none)) {
            > * {
            margin-bottom: ${space};
            }
        
            > :last-child {
            margin-bottom: 0px;
            }
        }
        
        @supports (not (gap: 0px)) {
            > * {
            margin-bottom: ${space};
            }
        
            > :last-child {
            margin-bottom: 0px;
            }
        }
    `;
};
